import React from 'react';
import { Field, Modal, Spinner } from '../../components/ui';
import { fmtDate, money, PAYMENT_MODES } from '../../utils/helpers';

// Mobile Expenses (phone browsers + APK): totals, expense cards grouped by
// category, tap a card for its payments. Full-screen forms. Logic: useExpenses.
export default function ExpensesMobile({ vm }) {
  const {
    canView, canAdd, canEdit, canDelete, loading, groups, totals, categories, functions, fnName, headcountOf, paidByOptions,
    q, setQ, openId, toggleOpen, openService,
    form, formTotal, formPersons, openAdd, openEdit, closeForm, setF, saveExpense, deleteExpense,
    payForm, openPayAdd, openPayEdit, closePay, setPF, savePayment, deletePayment, saving,
  } = vm;

  if (!canView) return <div className="card card-pad empty">You do not have access to expenses.</div>;

  return (
    <div className="expenses-page expenses-mobile">
      <div className="expense-tiles">
        <div className="expense-tile"><span>Total</span><strong>{money(totals.total)}</strong></div>
        <div className="expense-tile ok"><span>Paid</span><strong>{money(totals.paid)}</strong></div>
        <div className="expense-tile due"><span>Balance</span><strong>{money(totals.balance)}</strong></div>
      </div>
      <input type="search" className="expense-search" placeholder="Search…" value={q} onChange={e => setQ(e.target.value)} />

      {loading ? <Spinner /> : groups.length === 0 ? <div className="card card-pad empty">No expenses yet.</div> : groups.map(g => (
        <div key={g.category}>
          <div className="expense-cat-head"><strong>{g.category}</strong><span>{money(g.total)} · due {money(g.balance)}</span></div>
          {g.rows.map(e => (
            <div key={e.ExpenseId} className="card expense-card">
              <div className="expense-card-top" onClick={() => toggleOpen(e)}>
                <div style={{ minWidth: 0 }}>
                  <strong>{e.Title}</strong>{Number(e.IsEstimate) === 1 && <span className="chip warn" style={{ marginLeft: 6 }}>est.</span>}
                  <div className="muted" style={{ fontSize: 12 }}>
                    {[e.FunctionId ? fnName(e.FunctionId) : 'Whole event', e.AmountType === 'PerPerson' ? `${money(e.Rate)} × ${e.persons}` : null, e.VendorName].filter(Boolean).join(' · ')}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <strong>{money(e.total)}</strong>
                  <div style={{ fontSize: 12, color: e.balance > 0 ? 'var(--danger)' : 'var(--muted)' }}>due {money(e.balance)}</div>
                </div>
              </div>
              {openId === e.ExpenseId && (
                <div className="expense-card-body">
                  {e.payments.length === 0 && <div className="muted" style={{ fontSize: 13 }}>No payments yet.</div>}
                  {e.payments.map(p => (
                    <div key={p.ExpensePaymentId} className="expense-pay-line">
                      <span>{fmtDate(p.PaymentDate)}</span>
                      <strong>{money(p.Amount)}</strong>
                      <span className="muted">{[p.PaidBy, p.PaymentMode].filter(Boolean).join(' · ')}</span>
                      {canEdit && <button className="icon-btn" onClick={() => openPayEdit(p)}>✎</button>}
                      {canDelete && <button className="icon-btn danger" onClick={() => deletePayment(p)}>🗑</button>}
                    </div>
                  ))}
                  <div className="expense-card-actions">
                    {canAdd && <button className="btn primary sm" onClick={() => openPayAdd(e)}>+ Payment</button>}
                    {e.fromService ? (
                      <button className="btn light sm" onClick={() => openService(e)}>Open in Services</button>
                    ) : (
                      <>
                        {canEdit && <button className="btn light sm" onClick={() => openEdit(e)}>Edit</button>}
                        {canDelete && <button className="btn danger sm" onClick={() => deleteExpense(e)}>Delete</button>}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}

      {canAdd && <button className="btn primary guest-add-fab" onClick={() => openAdd()}>+ Expense</button>}
      <datalist id="expense-categories-m">{categories.map(c => <option key={c} value={c} />)}</datalist>
      <datalist id="expense-paidby-m">{paidByOptions.map(c => <option key={c} value={c} />)}</datalist>

      {form && (
        <Modal fullScreen title={form.ExpenseId ? 'Edit expense' : 'New expense'} onClose={closeForm}
          footer={<><button className="btn light" onClick={closeForm}>Cancel</button>
            <button className="btn primary" style={{ flex: 1 }} onClick={saveExpense} disabled={saving}>{saving ? 'Saving…' : `Save · ${money(formTotal)}`}</button></>}>
          <label className="field">Category *<input list="expense-categories-m" value={form.Category} onChange={e => setF('Category', e.target.value)} /></label>
          <Field label="Expense *" value={form.Title} onChange={(v) => setF('Title', v)} />
          <Field label="For function (blank = whole event)" type="select" value={form.FunctionId}
            options={functions.map(f => ({ value: String(f.FunctionId), label: f.FunctionName }))} onChange={(v) => setF('FunctionId', v)} />
          <Field label="Vendor / shop" value={form.VendorName} onChange={(v) => setF('VendorName', v)} />
          <Field label="Amount is" type="select" value={form.AmountType}
            options={[{ value: 'Fixed', label: 'A fixed amount' }, { value: 'PerPerson', label: 'Rate × persons' }]} onChange={(v) => setF('AmountType', v)} />
          {form.AmountType === 'Fixed' ? (
            <Field label="Total amount (₹)" value={form.TotalAmount} onChange={(v) => setF('TotalAmount', v)} />
          ) : (
            <>
              <Field label="Rate per person (₹)" value={form.Rate} onChange={(v) => setF('Rate', v)} />
              <Field label="Persons from" type="select" value={form.PersonsSource}
                options={[{ value: 'Headcount', label: 'A function’s headcount' }, { value: 'Manual', label: 'A number I type' }]} onChange={(v) => setF('PersonsSource', v)} />
              {form.PersonsSource === 'Headcount' ? (
                <Field label="Headcount of" type="select" value={form.PersonsFunctionId}
                  options={functions.map(f => ({ value: String(f.FunctionId), label: `${f.FunctionName} (${headcountOf(f.FunctionId)})` }))} onChange={(v) => setF('PersonsFunctionId', v)} />
              ) : <Field label="Persons" value={form.Persons} onChange={(v) => setF('Persons', v)} />}
              <div className="muted" style={{ fontSize: 13, marginBottom: 8 }}>{formPersons} persons × {money(form.Rate)}</div>
            </>
          )}
          <label className="expense-check" style={{ marginBottom: 10 }}>
            <input type="checkbox" checked={!!form.IsEstimate} onChange={e => setF('IsEstimate', e.target.checked ? 1 : 0)} /> Estimate (final amount not known)
          </label>
          <Field label="Notes" type="textarea" rows={2} value={form.Notes} onChange={(v) => setF('Notes', v)} />
        </Modal>
      )}

      {payForm && (
        <Modal fullScreen title={payForm.ExpensePaymentId ? 'Edit payment' : 'Add payment'} onClose={closePay}
          footer={<><button className="btn light" onClick={closePay}>Cancel</button>
            <button className="btn primary" style={{ flex: 1 }} onClick={savePayment} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button></>}>
          <Field label="Date *" type="date" value={payForm.PaymentDate} onChange={(v) => setPF('PaymentDate', v)} />
          <Field label="Amount (₹) *" value={payForm.Amount} onChange={(v) => setPF('Amount', v)} />
          <label className="field">Paid by<input list="expense-paidby-m" value={payForm.PaidBy} onChange={e => setPF('PaidBy', e.target.value)} /></label>
          <Field label="Mode" type="select" value={payForm.PaymentMode} options={PAYMENT_MODES} onChange={(v) => setPF('PaymentMode', v)} />
          <Field label="Notes" value={payForm.Notes} onChange={(v) => setPF('Notes', v)} />
        </Modal>
      )}
    </div>
  );
}
